import { useMemo } from 'react';

export const FILTER_OPTIONS = ['Все', 'Активные', 'Завершённые']

export const useHistoryData = ({ switchActive, filter, activePacks, archivePacks, history, upcoming }) => {
    const packsToShow = useMemo(() => {
        if (filter === 'Активные') return activePacks?.data ?? []
        if (filter === 'Завершённые') return archivePacks?.data ?? []
        return [...(activePacks?.data ?? []), ...(archivePacks?.data ?? [])]
    }, [filter, activePacks, archivePacks])

    const lessonsList = useMemo(
        () => history?.pages?.flatMap((page) => page?.data?.data ?? []) ?? [],
        [history]
    )

    const historyTotal = useMemo(
        () => history?.pages?.[0]?.data?.total ?? lessonsList.length,
        [history, lessonsList]
    )

    const upcomingLessons = useMemo(() => {
        const list = Array.isArray(upcoming)
            ? upcoming
            : upcoming?.id
                ? [upcoming]
                : []
        return list.map((lesson) => ({ ...lesson, status: 'active' }))
    }, [upcoming])

    const lessonsToShow = useMemo(() => {
        if (filter === 'Активные') return upcomingLessons
        if (filter === 'Завершённые') return lessonsList
        return [...upcomingLessons, ...lessonsList]
    }, [filter, upcomingLessons, lessonsList])

    const activeCount = useMemo(
        () => switchActive ? upcomingLessons.length : (activePacks?.total ?? 0),
        [switchActive, upcomingLessons.length, activePacks]
    )

    const completedCount = useMemo(
        () => switchActive ? historyTotal : (archivePacks?.total ?? 0),
        [switchActive, historyTotal, archivePacks]
    )

    return {
        packsToShow,
        lessonsToShow,
        upcomingLessons,
        activeCount,
        completedCount,
        historyTotal,
    }
}
